// extracted by mini-css-extract-plugin
export var listItem = "mobile-utility-bar-module--listItem--f80c9";
export var listLabel = "mobile-utility-bar-module--listLabel--c187c";
export var navSection = "mobile-utility-bar-module--navSection--9cdc9";
export var wrapper = "mobile-utility-bar-module--wrapper--a208b";